import React, { useRef } from 'react';
import ImportEditor from './ImportEditor';
import FileControls from './FileControls';
import { PreferencesProvider } from '../../context/PreferencesContext'; // Corrected path

import './EditorPage.css';
import Footer from '../common/Footer';


const EditorPage = () => {
  const importEditorRef = useRef(null);  // Initialize ref with null

  // Function to provide data to FileControls
  const handleGetData = () => {
    if (importEditorRef.current) {
      const data = importEditorRef.current.getData();  // Get data from ImportEditor
      return data;
    }
    return null;
  };

  // Function to handle imported JSON data
  const handleImportJSON = (importedData) => {
    if (importEditorRef.current) {
      importEditorRef.current.importPerformanceData(importedData);  // Call import function
    }
  };

  return (
    <div className="app-container">
      <div className="beta-banner">beta-version 0.2.0</div>

      <div className="main-content">
        <PreferencesProvider>
          <FileControls getData={handleGetData} onImportJSON={handleImportJSON} />
        </PreferencesProvider>

        <div className="editor-page-main-div">
          <ImportEditor ref={importEditorRef} />
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default EditorPage;
